export default {"src":"/_next/static/media/globe-earth-white.841e3aa2.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};